import { Dispatch } from "redux";
import { setAxnSessionsLoading, setAxnSessions } from "@redux/actions/axn-sessions-actions";
import { FormattedAxnSession } from "@idw-types/data/management-console/axn";
import { getActiveAxnSessionsRequest } from "@requests/management-console/get-active-axn-sessions";
import { formatAxnSessions } from "@formatters/management-console/axn/axn-session-formatter";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const getAxnSessionsReduxRequest = (dispatch: Dispatch) => async (): Promise<Array<FormattedAxnSession>> => {
    dispatch(setAxnSessionsLoading(true));
    const { data, error } = await getActiveAxnSessionsRequest();
    if (data?.sessions) {
        const formattedAxnSessions = formatAxnSessions(data.sessions);
        dispatch(setAxnSessions(formattedAxnSessions));
        return formattedAxnSessions;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getAxnSessions.error.title,
                resources.requests.getAxnSessions.error.message
            );
        }
        dispatch(setAxnSessionsLoading(false));
        return null;
    }
};